<template>
    <div class="stuwarp">
        <Header title="学籍"></Header>
        <div class="stucontent" v-for="(item, index) in dataList" :key="index">
            <div class="title">
                基本信息
            </div>
            <van-form>
                <van-field v-model="item.xm" name="用户名" label="用户名" disabled input-align="right" />
                <van-field v-model="item.xh" name="学号" label="学号" disabled input-align="right" />
                <van-field v-model="item.xb" name="性别" label="性别" disabled input-align="right" />
                <van-field v-model="item.csrq" name="出生日期" label="出生日期" disabled input-align="right" />
                <van-field v-model="item.csd" name="出生地" label="出生地" disabled input-align="right" />
                <van-field v-model="item.gj" name="国籍" label="国籍" disabled input-align="right" />
                <van-field v-model="item.mz" name="民族" label="民族" disabled input-align="right" />
                <van-field v-model="item.jg" name="籍贯" label="籍贯" disabled input-align="right" />
                <van-field v-model="item.dh" name="联系电话" label="联系电话" disabled input-align="right" />
                <van-field v-model="item.zzmm" name="政治面貌" label="政治面貌" disabled input-align="right" />
                <van-field v-model="item.txdz" name="通讯地址" label="通讯地址" disabled input-align="right" />
                <van-field v-model="item.dzxx" name="电子信箱" label="电子信箱" disabled input-align="right" />
            </van-form>
            <div class="title">其他信息</div>
            <van-form>
                <van-field v-model="item.rxnf" name="入学年份" label="入学年份" disabled input-align="right" />
                <van-field v-model="item.byjb" name="毕业界别" label="毕业界别" disabled input-align="right" />
                <van-field v-model="item.xsdqzt" name="学生当前状态" label="学生当前状态" disabled input-align="right" />
                <van-field v-model="item.xslb" name="学业类别" label="学业类别" disabled input-align="right" />
                <van-field v-model="item.zxzt" name="在校状态" label="在校状态" disabled input-align="right" />
                <van-field v-model="item.dqszj" name="年级" label="年级" disabled input-align="right" />
                <van-field v-model="item.dwmc" name="学院" label="学院" disabled input-align="right" />
                <van-field v-model="item.zymc" name="专业" label="专业" disabled input-align="right" />
                <van-field v-model="item.bj" name="班级" label="班级" disabled input-align="right" />
                <van-field v-model="item.bqname" name="学生标签" label="学生标签" disabled input-align="right" />
                <van-field v-model="item.xz" name="学制" label="学制" disabled input-align="right" />
                <van-field v-model="item.fxzy" name="辅修专业" label="辅修专业" disabled input-align="right" />
                <van-field v-model="item.fxbj" name="辅修班级" label="辅修班级" disabled input-align="right" />
                <van-field v-model="item.pyfamc" name="个性培养方案" label="个性培养方案" disabled input-align="right" />
                <van-field v-model="item.sfjxhd" name="是否教学活动" label="是否教学活动" disabled input-align="right" />
            </van-form>
        </div>
    </div>
</template>

<script>
import { Api } from '../../../../utils/axios';

export default {
    data() {
        return {
            username: '',
            password: '',
            xsxjList: '',
            dataList: []
        };
    },
    created() {
        this.xsxjList = this.$route.query.xs0101id;
        this.getSosoXsxx();
    },
    methods: {
        async getSosoXsxx() {
            const params = {
                xs0101id: this.xsxjList
            };
            const res = await Api.getSosoXsxx(params);
            this.dataList = res.data;
        }
    }
};
</script>

<style lang="less" scoped>
.stuwarp {
    .stucontent {
        .title {
            width: 100%;
            height: 40px;
            background: #f2f2f4;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            padding: 14px 0 6px 15px;
            line-height: 36px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/informationService/studentStatus.vue